import React, { useEffect, useState } from "react";
import GrayTheme from "./GrayTheme";
// import { styled } from "@mui/material/styles";
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  // Autocomplete,
  DirectionsRenderer,
  InfoWindow,
} from "@react-google-maps/api";
// import location from "../../../assets/images/location.png";
import Locationicon from "../../../assets/images/Locationicon.png";
import { GoogleMapMainDiv } from "./AutocompleteStyle";
// import pickupicon from "../../../assets/images/pickup.png";
// import dropofficon from "../../../assets/images/dropoff.png";

const MapKey =
  process.env.REACT_APP_GOOGLE_MAP_KEY ||
  "AIzaSyDYENkK5g10o0FwB1aYjcYXOs_WEXv3IbM";

const GoogleMaps = ({
  LocationIcon = true,
  CurrentUserLocation = null,
  hasRoutes = false,
  PichUpLocation = "",
  DropoffLocation = "",
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MapKey,
    libraries: ["places"],
  });
  // "directions"
  const [currentLocation, setCurrentLocation] = useState({ lat: 0, lng: 0 });
  const [directionsResponse, setDirectionsResponse] = useState(null);
  // const [directions, setDirections] = useState(null);
  // const [PickUp, setPickUp] = useState("");
  // const [DropOff, setDropOff] = useState("");
  const [map, setMap] = useState(/** @type google.maps.Map */ (null));

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting the current location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (currentLocation !== null && isLoaded) {
      calculateRoute();
    }
  }, [currentLocation, isLoaded]);

  async function calculateRoute() {
    if (currentLocation === "") {
      return;
    }
    const dummydestination = {
      lat: 31.5032339,
      lng: 74.33187459999999,
    };
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      // origin: pickupref.current.value,
      origin: PichUpLocation || currentLocation,
      destination: DropoffLocation || dummydestination,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });
    setDirectionsResponse(results);

    // setPickUp(results.routes[0].legs[0].distance.text);
    // setDropOff(results.routes[0].legs[0].duration.text);
  }

  if (!isLoaded) {
    return "Loading...";
  }

  // this is for show the InfoWindow on the routing line
  const desiredStep = 2;
  // const startLocation = directionsResponse?.routes[0]?.legs[0]?.start_location;
  const steps = directionsResponse?.routes[0]?.legs[0]?.steps;
  const desiredStepLocation =
    steps && desiredStep < steps.length
      ? steps[desiredStep]?.end_location
      : null;
  const endLocation = directionsResponse?.routes[0]?.legs[0]?.end_location;

  const mapContainerStyle = {
    width: "100%",
    height: hasRoutes ? "200px" : "100vh",
    // height: "100vh",
  };

  return (
    <>
      <GoogleMapMainDiv className="custon_GoogleMap">
        {isLoaded && (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={hasRoutes ? 11 : 15}
            center={CurrentUserLocation || currentLocation}
            options={{
              fullscreenControl: false,
              backgroundColor: "gray",
              zoomControl: false,
              scrollwheel: false,
              mapTypeControl: false,
              gestureHandling: "cooperative",
              streetViewControl: false,
              styles: GrayTheme,
            }}
            onLoad={(map) => setMap(CurrentUserLocation || currentLocation)}
          >
            {/* show the current user location marker   */}
            {LocationIcon && (
              <Marker
                position={CurrentUserLocation || currentLocation}
                icon={Locationicon}
                animation={2}
              />
            )}

            {isLoaded && hasRoutes && directionsResponse && (
              <>
                <DirectionsRenderer
                  directions={directionsResponse}
                  options={{
                    polylineOptions: {
                      strokeColor: "#0B0B0B",
                      strokeWeight: 3,
                      fillColor: "#FF0000",
                      radius: 30000,
                    },
                    suppressMarkers: true,
                    preserveViewport: true,
                  }}
                />
                <Marker
                  position={directionsResponse.routes[0].legs[0].start_location}
                  icon={Locationicon}
                />
                <Marker
                  position={directionsResponse.routes[0].legs[0].end_location}
                  icon={Locationicon}
                />

                {isLoaded && (desiredStepLocation || endLocation) && (
                  <InfoWindow position={desiredStepLocation || endLocation}>
                    <div className="distance_main">
                      <p>
                        {directionsResponse.routes[0].legs[0].distance.text}
                      </p>
                      <p>
                        {directionsResponse.routes[0].legs[0].duration.text}
                      </p>
                    </div>
                  </InfoWindow>
                )}
              </>
            )}
          </GoogleMap>
        )}
      </GoogleMapMainDiv>
    </>
  );
};

export default GoogleMaps;
